import React, { FunctionComponent } from "react";

interface HighlightedTextProps {
  text: string;
}

// Renders text with **bold** segments wrapped in <strong>.
export const HighlightedText: FunctionComponent<HighlightedTextProps> = ({ text }) => (
  <>
    {text
      .split(/(\*\*.*?\*\*)/)
      .map((part, index) =>
        part.startsWith("**") && part.endsWith("**") ? <strong key={index}>{part.slice(2, -2)}</strong> : part
      )}
  </>
);
